<template>
  <el-table
    :data="itemsToShow"
    style="border: 2px solid #ebeef5; width: 100%; min-height: 65vh"
    ref="jobHistoryTable"
    row-class-name="body-row"
    highlight-current-row
    max-height="65vh"
    @current-change="selectJobHistory"
    @expand-change="expandCollapseJob"
  >
    <el-table-column type="expand"
      ><template slot-scope="props" v-if="props.row.activities.length > 0">
        <el-table
          :data="props.row.activities"
          highlight-current-row
          :show-header="false"
          ref="taskHistoryTable"
          row-class-name="body-row"
          @row-click="selectActivityHistory"
        >
          <el-table-column width="48"
            ><template slot-scope="scope"
              ><center>
                <i
                  :class="
                    scope.row.type === 'Process'
                      ? 'el-icon-setting'
                      : 'el-icon-tickets'
                  "
                /></center></template
          ></el-table-column>
          <el-table-column prop="name" />
        </el-table> </template
    ></el-table-column>
    <template v-for="column in tableFormat">
      <el-table-column
        v-if="column.prop"
        :key="column.label"
        :prop="column.prop"
        :label="column.label"
        sortable
        :sort-method="column.sortMethod"
        :min-width="20"
        :filters="column.filterOption"
        :filter-method="column.filterMethod"
        :filter-placement="column.filterPlacement"
      />
    </template>
  </el-table>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    itemsToShow: Array,
    tableFormat: Array,
  },
  data() {
    return {
      timezone:
        process.env.VUE_APP_SERVER_TIMEZONE ||
        Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  },
  computed: {
    ...mapState([
      "currentTaskName",
      "instanceId",
      "taskId",
      "isUserLoggedIn",
      "environmentId",
    ]),
  },
  methods: {
    selectJobHistory(row) {
      this.$emit("selectJobHistory", row);
    },
    selectActivityHistory(row) {
      this.$emit("selectActivityHistory", row);
    },
    expandCollapseJob(row, expandedRows) {
      this.$emit("expandCollapseJob", row, expandedRows);
    },
  },
  mounted() {
    if (this.itemsToShow.length > 0) {
      this.$refs.jobHistoryTable.setCurrentRow(this.itemsToShow[0]);
    }
  },
};
</script>
<style scoped>
.card {
  font-size: 14px;
  color: #606266;
}
.el-card :deep(.el-card__header) {
  background-color: #f0f0f0;
  padding: 10px 20px;
}
.el-card :deep(.el-card__body) {
  padding: 10px 20px;
}
</style>